"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("../../functions/style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var BodyColumn = function BodyColumn(_ref) {
  var children = _ref.children,
      width = _ref.width,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClick,
    className: "".concat(width === 'auto' ? 'flex-auto' : '', " pl2 __body_column flex items-stretch"),
    style: (0, _style.getStyle)(width)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center col-12"
  }, children));
};

BodyColumn.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object]),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onClick: _propTypes.default.func
};
var _default = BodyColumn;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(BodyColumn, "BodyColumn", "/Users/darcy/sites/cs-theme/src/components/table/body/column/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/table/body/column/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();